import { handlePeriodSelected } from './utils';

export const getters = {
  getterGroupIdList: (state) => {
    return state.groupList.map(group => group.id);
  },

  getFanbaseEvolutionPeriod: (state, _, rootState) => {
    const periodSelected = rootState.charts.fanbaseEvolution.periodSelected;

    return handlePeriodSelected(periodSelected, { dateRange: state.dateRange });
  },

  getInteractionsOverTimePeriod: (state, _, rootState) => {
    const periodSelected = rootState.charts.interactionsOverTime.periodSelected;

    return handlePeriodSelected(periodSelected, { dateRange: state.dateRange });
  },

  getEngagementOverTimePeriod: (state, _, rootState) => {
    const periodSelected = rootState.charts.engagementOverTime.periodSelected;

    return handlePeriodSelected(periodSelected, { dateRange: state.dateRange });
  },

  getSentimentsInTheCommentsOverTimePeriod: (state, _, rootState) => {
    const periodSelected = rootState.charts.sentimentsInTheCommentsOverTime.periodSelected;

    return handlePeriodSelected(periodSelected, { dateRange: state.dateRange });
  },

  getPublicationsOverTimeWithDistributionPeriod: (state, _, rootState) => {
    const periodSelected = rootState.charts.publicationsOverTimeWithDistribution.periodSelected;

    return handlePeriodSelected(periodSelected, { dateRange: state.dateRange });
  },
};
